
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/international-logistics",
      function () {
        return require("private-next-pages/services/international-logistics.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/international-logistics"])
      });
    }
  